var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.5 27.5C55.5 42.6878 43.1878 55 28 55C12.8122 55 0.5 42.6878 0.5 27.5C0.5 12.3122 12.8122 0 28 0C43.1878 0 55.5 12.3122 55.5 27.5ZM9.07497 27.5C9.07497 37.952 17.548 46.425 28 46.425C38.452 46.425 46.925 37.952 46.925 27.5C46.925 17.048 38.452 8.57497 28 8.57497C17.548 8.57497 9.07497 17.048 9.07497 27.5Z",
    fill: "#F7665F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2125 27.5C53.5804 27.5 55.5341 25.569 55.1664 23.2298C54.8298 21.088 54.2402 18.9885 53.4067 16.9762C52.0247 13.6398 49.999 10.6082 47.4454 8.05456C44.8918 5.50095 41.8602 3.47532 38.5238 2.09331C36.5115 1.25977 34.412 0.670219 32.2702 0.333555C29.931 -0.0341329 28 1.91957 28 4.28748V4.28748C28 6.65539 29.9435 8.52669 32.2509 9.05856C33.2705 9.29357 34.2711 9.61327 35.2423 10.0155C37.5384 10.9666 39.6247 12.3606 41.382 14.118C43.1394 15.8753 44.5334 17.9616 45.4845 20.2577C45.8867 21.2289 46.2064 22.2295 46.4414 23.2491C46.9733 25.5565 48.8446 27.5 51.2125 27.5V27.5Z",
    fill: "#F7665F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.ebac7aa626fcc7601ab40c0f3504d063.svg";
export { ForwardRef as ReactComponent };